let doc = $(document);

doc.ready(function () {
    doc.on("click", "[data-modal-close-target]", function () {
        let modalId = $(this).attr("data-modal-close-target");
        $("#" + modalId).hide(100);
    });
    doc.on("click", "[data-modal-open-target]", function () {
        let modalId = $(this).attr("data-modal-open-target");
        $("#" + modalId).show(100);
    });
    doc.on("click", ".modal", function (e) {
        if(!$(this).find(".modal_card")[0].contains(e.target)){
            $(this).hide(100);
            dispatchModalCloseEvent($(this).attr("id"));
        }
    });

    doc.on("click", ".modal_cancel", function () {
        $(this).closest(".modal").hide(100);
        dispatchModalCloseEvent($(this).closest(".modal").attr("id"));
    });
});

function dispatchModalCloseEvent(modalId) {
    if(!modalId){
        return;
    }
    
    if(modalId === "release_notes_modal"){
        window.dispatchEvent(new CustomEvent("handle-release-notes-modal-close"));
    }
}
